import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { NavLink } from 'fluxible-router';
import styles from './styles.module.styl';

const JobCard = (props) => {
  const { title, description, imageUrl, articles } = props;

  return (
    <div className={`${styles.jobCard}`}>
      <div className={`${styles.jobCardContainer} container`}>
        <div className={`${styles.jobCardLogo} col-xs-4`}>
          <img src={imageUrl} />
        </div>

        <div className={`${styles.jobCardMain} col-xs-8`}>
          <h3>{title}</h3>
          <p>{description}</p>

          <ul className={styles.jobCardArticles}>
            {articles.map(article => (
              <li key={article.url}>
                {/* TODO - hack to get around navigation issue in prod */}
                {article.url === "https://auth0.com/partners/" ?
                  <a href={article.url}>{article.title}</a> :
                  <NavLink href={article.url} followLink={article.forceFullReload}>
                    {article.title}
                  </NavLink>}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

JobCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
  articles: PropTypes.array
};

export default JobCard;
